import dateFnsFormat from 'date-fns/format';

export const getDateFromTimeStamp = (timeStamp) => {
  return new Date(timeStamp * 1000);
};

export const getDateByFormat = (dateformat) => {
  return (date) => dateFnsFormat(date, dateformat);
};
